module.exports = __webpack_public_path__ + "static/img/kf_cloud_00000.6eb12f7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/kf_cloud_00000.jpg
// module id = 171
// module chunks = 1